/* globals navigator Raven */

import React, { Component, PropTypes } from 'react';
import { routerShape } from 'react-router/lib/PropTypes';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { intlShape } from 'react-intl';
import ga from 'react-ga';
import { autobind } from 'core-decorators';

import {
  currentUser as currentUserAction,
  fetchChargers,
  cachedChargers,
  logout,
  changeMap,
  setCurrentCharger,
} from 'actions';
import { byIdShape } from 'utils/propTypes';

import './styles.scss';

import Header from './components/Header';
import Footer from './components/Footer';


const checkCarBrowserFromUserAgent = userAgent => userAgent.includes('QtCarBrowser');


class App extends Component {

  static propTypes = {
    cache: PropTypes.shape({ all: PropTypes.string }).isRequired,
    changeMap: PropTypes.func.isRequired,
    chargersById: byIdShape.isRequired,
    children: PropTypes.node.isRequired,
    currentUser: PropTypes.number,
    currentUserRequest: PropTypes.func.isRequired,
    fetchCachedChargers: PropTypes.func.isRequired,
    fetchChargers: PropTypes.func.isRequired,
    imperialUnits: PropTypes.bool,
    isLoggedIn: PropTypes.bool,
    loggingIn: PropTypes.bool,
    loggingOut: PropTypes.bool,
    logoutRequest: PropTypes.func.isRequired,
    setCurrentCharger: PropTypes.func.isRequired,
    usersById: byIdShape.isRequired,
  };

  static defaultProps = {
    currentUser: null,
    imperialUnits: true,
    isLoggedIn: false,
    loggingIn: false,
    loggingOut: false,
  };

  static contextTypes = {
    intl: intlShape.isRequired,
    router: routerShape.isRequired,
  };

  static childContextTypes = {
    appClass: PropTypes.string,
    imperial: PropTypes.bool,
    isCarBrowser: PropTypes.bool,
  };

  constructor(props, context) {
    super(props, context);
    this.state = {
      isCarBrowser: false,
    };
    let userAgent = null;
    if (typeof navigator !== 'undefined') userAgent = navigator.userAgent;
    else if (global.requestHeaders) userAgent = global.requestHeaders.HTTP_USER_AGENT;
    if (userAgent) {
      this.state.isCarBrowser = checkCarBrowserFromUserAgent(userAgent);
    }
  }

  getChildContext() {
    return {
      isCarBrowser: this.state.isCarBrowser,
      appClass: this.getAppClass(),
      imperial: this.useImperialUnits(),
    };
  }

  componentWillMount() {
    if (typeof navigator !== 'undefined') {
      this.setState({
        isCarBrowser: checkCarBrowserFromUserAgent(navigator.userAgent),
      });
    }
  }

  componentDidMount() {
    this.props.fetchCachedChargers(this.props.cache.all);
    if (this.props.currentUser === null) this.props.currentUserRequest();
    if (this.props.isLoggedIn) {
      this.gaSetUser();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.isLoggedIn !== nextProps.isLoggedIn) {
      this.gaSetUser(nextProps);
    }
  }

  getAppClass() {
    return this.state.isCarBrowser ? 'car-browser' : 'not-car-browser';
  }

  gaSetUser(props) {
    const { currentUser, usersById } = props || this.props;
    const user = usersById[currentUser];
    if (user) {
      ga.set({ userId: user.username });
      Raven.setUserContext({
        id: currentUser,
        username: user.username,
        email: user.email,
      });
    } else {
      ga.set({ userId: null });
      Raven.setUserContext({
        id: null,
        username: null,
        email: null,
      });
    }
  }

  useImperialUnits() {
    const user = this.props.usersById[this.props.currentUser];
    if (user) return user.imperial_units;
    return this.props.imperialUnits;
  }

  @autobind
  handleSearchResultClick(pk) {
    if (this.props.children.props.route.name === 'home') {
      const charger = this.props.chargersById[pk];
      let coords = charger.address.coords.coordinates;
      if (charger.custom_coords) coords = charger.custom_coords.coordinates;
      this.props.changeMap({
        lat: coords[1],
        lng: coords[0],
      }, 17);
      this.props.setCurrentCharger(pk);
      this.props.fetchChargers({
        include: [pk],
      });
    } else {
      this.context.router.push(`/charger/${pk}/`);
    }
  }

  render() {
    const routeName = this.props.children.props.route.name;

    return (
      <div id='page' className={routeName} styleName='page'>

        <Helmet
          title='Chargerville'
          defaultTitle='Chargerville'
          titleTemplate='%s | Chargerville'
          htmlAttributes={{
            lang: this.context.intl.locale,
            class: this.getAppClass(),
          }}
        />

        <Header
          isLoggedIn={this.props.isLoggedIn}
          loggingIn={this.props.loggingIn}
          loggingOut={this.props.loggingOut}
          handleLogout={this.props.logoutRequest}
          currentUser={this.props.usersById[this.props.currentUser]}
          currentPath={this.props.children.props.route.path}
          chargersById={this.props.chargersById}
          onSearchResultClick={this.handleSearchResultClick}
          currentRoute={routeName}
        />

        <main>
          { this.props.children }
        </main>

        <Footer />

      </div>
    );
  }

}

const mapStateToProps = state => ({
  isLoggedIn: state.auth.isLoggedIn,
  loggingIn: state.auth.loggingIn,
  loggingOut: state.auth.loggingOut,
  usersById: state.users.byId,
  chargersById: state.chargers.byId,
  currentUser: state.auth.currentUser,
  cache: state.chargers.cache,
  imperialUnits: state.locale.imperialUnits,
});

const fetchCachedChargers = cachedChargers.request;

const currentUserRequest = currentUserAction.request;

const logoutRequest = logout.request;

export default connect(
  mapStateToProps, {
    currentUserRequest,
    fetchCachedChargers,
    fetchChargers,
    logoutRequest,
    changeMap,
    setCurrentCharger,
  })(App);



// WEBPACK FOOTER //
// ./app/scripts/views/App/index.jsx